import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Bitacoras from "./pages/Bitacoras";
import IngresoFactura from "./pages/IngresoFactura";
import AdendaBitacora from "./pages/AdendaBitacora";
import ConceptosGasto from "./pages/ConceptosGasto";
import EstatusFactura from "./pages/EstatusFactura";
import TiposFactura from "./pages/TiposFactura";
import FacturasTimbradas from "./pages/FacturasTimbradas";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import { SidebarProvider } from "./context/SidebarContext";

function App() {
  return (
    <SidebarProvider>
      <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Layout title="Inicio">
                <Home />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bitacoras"
          element={
            <ProtectedRoute>
              <Layout title="Bitácoras">
                <Bitacoras />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/facturas-timbradas"
          element={
            <ProtectedRoute>
              <Layout title="Facturas Timbradas">
                <FacturasTimbradas />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ingreso-factura"
          element={
            <ProtectedRoute>
              <Layout title="Ingreso de Factura">
                <IngresoFactura />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/adenda-bitacora"
          element={
            <ProtectedRoute>
              <Layout title="Adenda Bitácora">
                <AdendaBitacora />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/conceptos-gasto"
          element={
            <ProtectedRoute>
              <Layout title="Conceptos de Gasto">
                <ConceptosGasto />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/estatus-factura"
          element={
            <ProtectedRoute>
              <Layout title="Estatus de Factura">
                <EstatusFactura />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tipos-factura"
          element={
            <ProtectedRoute>
              <Layout title="Tipos de Factura">
                <TiposFactura />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
      </Router>
    </SidebarProvider>
  );
}

export default App;
